// AUTO-GENERATED from public/onboarding/onboarding_funnel_dashboard.html by
// scripts/gen-onboarding.js — do not edit by hand. The onboarding funnel's original
// CSS/markup/logic, ported verbatim into a module. Only mechanical transforms were
// applied (see generator). It runs inside a Shadow DOM for style isolation.
/* eslint-disable */
export const ONB_CSS = "\n    :host {\n      color-scheme: dark;\n      --surface-0: #090d14;\n      --surface-1: #111827;\n      --surface-2: #151c2b;\n      --surface-3: #101622;\n      --surface-hover: #1c2638;\n      --border: #263244;\n      --border-strong: #35445a;\n      --border-stronger: #64748b;\n      --text-primary: #f4f7fb;\n      --text-secondary: #c4cedb;\n      --text-muted: #8794a8;\n      --text-accent: #67e8f9;\n      --fill-accent: #2563eb;\n      --on-accent: #f8fbff;\n      --fill-success: #22c55e;\n      --fill-warning: #f59e0b;\n      --fill-pro: #a78bfa;\n      --bg-success: #06351f;\n      --text-success: #86efac;\n      --bg-warning: #3a2504;\n      --text-warning: #fbbf24;\n      --bg-danger: #3b1116;\n      --text-danger: #fda4af;\n      --bg-pro: #25134d;\n      --text-pro: #c4b5fd;\n      --radius: 6px;\n      --shadow: 0 18px 45px rgba(0, 0, 0, 0.2), 0 1px 0 rgba(255, 255, 255, 0.03) inset;\n      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n    }\n\n    * { box-sizing: border-box; }\n    :host {\n      margin: 0;\n      min-height: 100vh;\n      background: radial-gradient(circle at top left, rgba(37, 99, 235, 0.12), transparent 34rem), var(--surface-0);\n      color: var(--text-primary);\n      font-size: 13px;\n    }\n    button, input, select, textarea {\n      font: inherit;\n    }\n    button {\n      cursor: pointer;\n    }\n    .sr-only {\n      position: absolute;\n      width: 1px;\n      height: 1px;\n      padding: 0;\n      margin: -1px;\n      overflow: hidden;\n      clip: rect(0, 0, 0, 0);\n      white-space: nowrap;\n      border: 0;\n    }\n    .topbar {\n      position: sticky;\n      top: 0;\n      z-index: 10;\n      background: var(--surface-2);\n      border-bottom: 1px solid var(--border);\n      box-shadow: var(--shadow);\n    }\n    .header {\n      min-height: 58px;\n      padding: 10px 20px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 16px;\n    }\n    .title {\n      margin: 0;\n      font-size: 16px;\n      line-height: 1.2;\n      font-weight: 650;\n    }\n    .subtitle {\n      margin: 3px 0 0;\n      font-size: 11px;\n      color: var(--text-muted);\n    }\n    .toolbar {\n      padding: 8px 20px;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      border-top: 1px solid var(--border);\n      background: var(--surface-3);\n    }\n    .tabs {\n      display: flex;\n      padding: 0 20px;\n      border-top: 1px solid var(--border);\n      overflow-x: auto;\n      background: var(--surface-2);\n    }\n    .tab {\n      padding: 10px 14px 9px;\n      border: 0;\n      border-bottom: 2px solid transparent;\n      background: transparent;\n      color: var(--text-secondary);\n      font-size: 12px;\n      font-weight: 600;\n      white-space: nowrap;\n    }\n    .tab.active {\n      color: var(--text-accent);\n      border-bottom-color: var(--fill-accent);\n    }\n    main {\n      padding: 20px;\n    }\n    .segmented {\n      display: inline-flex;\n      border: 1px solid var(--border-strong);\n      border-radius: var(--radius);\n      overflow: hidden;\n      background: var(--surface-2);\n    }\n    .segmented button {\n      border: 0;\n      background: transparent;\n      color: var(--text-secondary);\n      font-size: 11px;\n      font-weight: 600;\n      padding: 5px 12px;\n    }\n    .segmented button.active {\n      background: var(--fill-accent);\n      color: var(--on-accent);\n    }\n    .select, .input, .textarea {\n      border: 1px solid var(--border);\n      border-radius: var(--radius);\n      background: var(--surface-2);\n      color: var(--text-primary);\n      font-size: 11px;\n      padding: 5px 9px;\n      min-height: 29px;\n    }\n    .select:focus, .input:focus, .textarea:focus {\n      border-color: var(--text-accent);\n      box-shadow: 0 0 0 3px rgba(103, 232, 249, 0.12);\n      outline: none;\n    }\n    .input::placeholder, .textarea::placeholder {\n      color: var(--text-muted);\n    }\n    .input { width: 210px; }\n    .month-filter {\n      position: relative;\n      flex: 0 0 auto;\n    }\n    .month-button {\n      display: inline-flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 8px;\n      min-width: 170px;\n      min-height: 29px;\n      padding: 5px 9px;\n      border: 1px solid var(--border);\n      border-radius: var(--radius);\n      background: var(--surface-2);\n      color: var(--text-primary);\n      font-size: 11px;\n      font-weight: 600;\n    }\n    .month-menu {\n      position: absolute;\n      top: calc(100% + 6px);\n      left: 0;\n      z-index: 30;\n      display: none;\n      width: 240px;\n      max-height: 320px;\n      overflow: auto;\n      padding: 8px;\n      border: 1px solid var(--border-strong);\n      border-radius: 8px;\n      background: var(--surface-2);\n      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.38);\n    }\n    .month-filter.open .month-menu {\n      display: block;\n    }\n    .month-option {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      min-height: 28px;\n      padding: 5px 6px;\n      border-radius: var(--radius);\n      color: var(--text-secondary);\n      font-size: 11px;\n      font-weight: 600;\n    }\n    .month-option:hover {\n      background: var(--surface-hover);\n      color: var(--text-primary);\n    }\n    .month-option input {\n      accent-color: var(--fill-accent);\n    }\n    .month-menu-actions {\n      display: flex;\n      justify-content: space-between;\n      gap: 8px;\n      padding: 4px 4px 8px;\n      border-bottom: 1px solid var(--border);\n      margin-bottom: 4px;\n    }\n    .month-menu-actions button {\n      border: 0;\n      background: transparent;\n      color: var(--text-accent);\n      font-size: 11px;\n      font-weight: 700;\n      padding: 3px 4px;\n    }\n    .textarea {\n      width: 100%;\n      min-height: 90px;\n      resize: vertical;\n      font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n      line-height: 1.4;\n    }\n    .ghost-button, .primary-button {\n      border-radius: var(--radius);\n      font-size: 11px;\n      font-weight: 650;\n      min-height: 30px;\n      padding: 6px 12px;\n    }\n    .ghost-button {\n      border: 1px solid var(--border-strong);\n      background: transparent;\n      color: var(--text-secondary);\n    }\n    .primary-button {\n      border: 1px solid var(--fill-accent);\n      background: var(--fill-accent);\n      color: var(--on-accent);\n    }\n    .summary-strip {\n      margin-left: auto;\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 14px;\n      font-size: 11px;\n      color: var(--text-muted);\n    }\n    .summary-strip b {\n      color: var(--text-primary);\n      font-weight: 700;\n    }\n    .section-label {\n      margin: 0 0 10px;\n      color: var(--text-muted);\n      font-size: 11px;\n      font-weight: 700;\n      line-height: 1.3;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n    .panel {\n      background: var(--surface-2);\n      border: 1px solid var(--border);\n      border-radius: 8px;\n      box-shadow: var(--shadow);\n    }\n    .panel-head {\n      padding: 11px 15px;\n      border-bottom: 1px solid var(--border);\n    }\n    .panel-title {\n      margin: 0;\n      font-size: 12px;\n      font-weight: 700;\n    }\n    .panel-subtitle {\n      margin: 3px 0 0;\n      font-size: 10px;\n      color: var(--text-muted);\n    }\n    .grid-4 {\n      display: grid;\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n      gap: 10px;\n      margin-bottom: 16px;\n    }\n    .grid-2 {\n      display: grid;\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n      gap: 10px;\n    }\n    .funnel-primary-metrics {\n      display: grid;\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n      gap: 10px;\n      margin-bottom: 12px;\n    }\n    .funnel-secondary-metrics {\n      display: grid;\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n      gap: 10px;\n      max-width: 760px;\n      margin-bottom: 16px;\n    }\n    .funnel-secondary-metrics .metric-card {\n      padding: 12px 14px;\n      background: var(--surface-3);\n    }\n    .funnel-secondary-metrics .metric-value {\n      font-size: 22px;\n    }\n    .metric-card {\n      padding: 16px 18px;\n      background: var(--surface-2);\n      border: 1px solid var(--border);\n      border-radius: 8px;\n      box-shadow: var(--shadow);\n    }\n    .metric-label {\n      margin: 0;\n      color: var(--text-muted);\n      font-size: 10px;\n      font-weight: 700;\n      line-height: 1.35;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n    .metric-sub {\n      min-height: 26px;\n      margin: 2px 0 8px;\n      color: var(--border-stronger);\n      font-size: 10px;\n      line-height: 1.3;\n    }\n    .metric-value {\n      margin: 6px 0 3px;\n      font-size: 28px;\n      line-height: 1;\n      font-weight: 650;\n    }\n    .metric-value span {\n      margin-left: 4px;\n      color: var(--text-muted);\n      font-size: 12px;\n      font-weight: 450;\n    }\n    .bar {\n      width: 100%;\n      height: 4px;\n      margin: 11px 0 7px;\n      border-radius: 2px;\n      background: var(--surface-1);\n      overflow: hidden;\n    }\n    .bar > span {\n      display: block;\n      height: 100%;\n      border-radius: inherit;\n    }\n    .metric-foot {\n      margin: 0;\n      color: var(--text-muted);\n      font-size: 11px;\n    }\n    .metric-foot b {\n      color: var(--text-secondary);\n    }\n    .funnel-panel {\n      padding: 16px 20px;\n      margin-bottom: 16px;\n    }\n    .funnel {\n      display: grid;\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n      align-items: stretch;\n    }\n    .stage {\n      position: relative;\n      text-align: center;\n      padding: 0 6px;\n    }\n    .stage-line {\n      width: 82%;\n      height: 6px;\n      margin: 0 auto;\n      border-radius: 99px;\n    }\n    .stage-bridge {\n      position: absolute;\n      left: 0;\n      top: 1px;\n      transform: translateX(-50%);\n      padding: 0 5px;\n      background: var(--surface-2);\n      color: var(--text-muted);\n      font-size: 10px;\n      white-space: nowrap;\n    }\n    .stage-count {\n      margin-top: 10px;\n      font-size: 27px;\n      line-height: 1;\n      font-weight: 700;\n    }\n    .stage-label {\n      margin-top: 4px;\n      color: var(--text-muted);\n      font-size: 10px;\n    }\n    .stage-pct {\n      margin-top: 2px;\n      color: var(--text-muted);\n      font-size: 10px;\n      opacity: 0.75;\n    }\n    .table-shell {\n      overflow: hidden;\n    }\n    .table-tools {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 10px;\n      min-height: 48px;\n      padding: 9px 14px;\n      border-bottom: 1px solid var(--border);\n    }\n    .table-wrap {\n      width: 100%;\n      overflow: auto;\n    }\n    table {\n      width: 100%;\n      border-collapse: collapse;\n      font-size: 12px;\n    }\n    th, td {\n      padding: 8px 12px;\n      border-bottom: 1px solid var(--border);\n      text-align: left;\n      vertical-align: middle;\n      white-space: nowrap;\n    }\n    th {\n      position: sticky;\n      top: 0;\n      z-index: 1;\n      background: var(--surface-1);\n      color: var(--text-muted);\n      font-size: 11px;\n      font-weight: 700;\n    }\n    th.sortable {\n      cursor: pointer;\n      user-select: none;\n    }\n    tbody tr:hover {\n      background: var(--surface-hover);\n    }\n    .muted { color: var(--text-muted); }\n    .secondary { color: var(--text-secondary); }\n    .strong { color: var(--text-primary); font-weight: 650; }\n    .success-text { color: var(--text-success); font-weight: 650; }\n    .accent-text { color: var(--text-accent); font-weight: 650; }\n    .pro-text { color: var(--text-pro); font-weight: 650; }\n    .badge, .day-chip {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-height: 19px;\n      border-radius: var(--radius);\n      line-height: 1;\n      white-space: nowrap;\n    }\n    .badge {\n      padding: 3px 8px;\n      font-size: 10px;\n      font-weight: 700;\n    }\n    .day-chip {\n      padding: 3px 7px;\n      font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n      font-size: 11px;\n      font-weight: 700;\n    }\n    .status-cluster {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 4px;\n      min-width: 190px;\n      max-width: 280px;\n      white-space: normal;\n    }\n    .mini-status {\n      display: inline-flex;\n      align-items: center;\n      gap: 5px;\n      min-height: 20px;\n      padding: 2px 6px;\n      border: 1px solid var(--border);\n      border-radius: var(--radius);\n      background: var(--surface-1);\n      color: var(--text-secondary);\n      font-size: 10px;\n      font-weight: 700;\n      line-height: 1;\n    }\n    .mini-status.live,\n    .mini-status.done {\n      border-color: rgba(34, 197, 94, 0.32);\n      background: var(--bg-success);\n      color: var(--text-success);\n    }\n    .mini-status.missing {\n      border-color: rgba(253, 164, 175, 0.28);\n      background: var(--bg-danger);\n      color: var(--text-danger);\n    }\n    .platform-dot {\n      width: 7px;\n      height: 7px;\n      border-radius: 99px;\n      flex: 0 0 auto;\n      box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12);\n    }\n    .status-mark {\n      font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n      font-size: 11px;\n      line-height: 1;\n    }\n    .center-cell {\n      text-align: center;\n    }\n    .tat-col {\n      width: 86px;\n      min-width: 86px;\n      max-width: 86px;\n      text-align: center;\n      white-space: normal;\n      line-height: 1.15;\n    }\n    th.tat-col {\n      padding-left: 6px;\n      padding-right: 6px;\n      font-size: 10px;\n    }\n    td.tat-col {\n      padding-left: 6px;\n      padding-right: 6px;\n    }\n    .client-cell {\n      max-width: 185px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n    .legend {\n      margin-left: auto;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 6px;\n      color: var(--text-muted);\n      font-size: 10px;\n    }\n    .legend span {\n      display: inline-flex;\n      align-items: center;\n      min-height: 18px;\n      padding: 2px 7px;\n      border-radius: var(--radius);\n    }\n    .note {\n      margin: 9px 15px 12px;\n      color: var(--text-muted);\n      font-size: 10px;\n      font-style: italic;\n    }\n    .modal-backdrop {\n      position: fixed;\n      inset: 0;\n      z-index: 50;\n      display: none;\n      align-items: center;\n      justify-content: center;\n      padding: 20px;\n      background: rgba(2, 6, 12, 0.72);\n    }\n    .modal-backdrop.open {\n      display: flex;\n    }\n    .modal {\n      width: min(720px, 100%);\n      max-height: min(86vh, 760px);\n      overflow: auto;\n      background: var(--surface-2);\n      border: 1px solid var(--border);\n      border-radius: 8px;\n      box-shadow: 0 28px 80px rgba(0, 0, 0, 0.55);\n    }\n    .modal-head {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 14px 16px;\n      border-bottom: 1px solid var(--border);\n    }\n    .modal-body {\n      padding: 16px;\n    }\n    .modal-title {\n      margin: 0;\n      font-size: 14px;\n      font-weight: 700;\n    }\n    .close-button {\n      width: 28px;\n      height: 28px;\n      border: 0;\n      border-radius: var(--radius);\n      background: transparent;\n      color: var(--text-muted);\n      font-size: 20px;\n      line-height: 1;\n    }\n    .field {\n      margin-bottom: 12px;\n    }\n    .field label {\n      display: block;\n      margin-bottom: 5px;\n      color: var(--text-secondary);\n      font-size: 11px;\n      font-weight: 700;\n    }\n    .modal-actions {\n      display: flex;\n      justify-content: flex-end;\n      gap: 8px;\n      padding-top: 4px;\n    }\n    .error {\n      display: none;\n      margin: 0 0 12px;\n      color: var(--text-danger);\n      font-size: 11px;\n    }\n    .empty {\n      padding: 48px 24px;\n      text-align: center;\n    }\n    .empty h3 {\n      margin: 0 0 6px;\n      font-size: 13px;\n    }\n    .empty p {\n      margin: 0 0 16px;\n      color: var(--text-muted);\n      font-size: 11px;\n    }\n    .chart-panel {\n      overflow: hidden;\n    }\n    .trend-grid {\n      display: grid;\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n      gap: 10px;\n    }\n    .chart-wrap {\n      padding: 12px 14px 16px;\n      overflow-x: auto;\n    }\n    .trend-chart {\n      display: block;\n      width: 100%;\n      min-width: 430px;\n      height: auto;\n    }\n    .trend-chart text {\n      fill: var(--text-muted);\n      font-size: 11px;\n    }\n    .trend-chart .axis-line {\n      stroke: var(--border-strong);\n      stroke-width: 1;\n    }\n    .trend-chart .grid-line {\n      stroke: var(--border);\n      stroke-width: 1;\n      opacity: 0.7;\n    }\n    .trend-chart .series-line {\n      fill: none;\n      stroke-width: 2.4;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n    .trend-chart .series-point {\n      stroke: var(--surface-2);\n      stroke-width: 2;\n    }\n    .chart-legend {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      padding: 0 14px 14px;\n    }\n    .legend-key {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      min-height: 22px;\n      padding: 3px 8px;\n      border: 1px solid var(--border);\n      border-radius: var(--radius);\n      background: var(--surface-1);\n      color: var(--text-secondary);\n      font-size: 11px;\n      font-weight: 700;\n    }\n    .legend-swatch {\n      width: 9px;\n      height: 9px;\n      border-radius: 99px;\n    }\n    .actionable-summary {\n      display: grid;\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n      gap: 10px;\n      margin-bottom: 12px;\n    }\n    .actionable-secondary-summary {\n      display: grid;\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n      gap: 10px;\n      margin: -2px 0 12px;\n      max-width: 760px;\n    }\n    .actionable-tile {\n      padding: 12px 14px;\n      background: var(--surface-2);\n      border: 1px solid var(--border);\n      border-radius: 8px;\n      box-shadow: var(--shadow);\n    }\n    .actionable-tile.filterable {\n      cursor: pointer;\n      text-align: left;\n      transition: border-color 120ms ease, background 120ms ease, transform 120ms ease;\n    }\n    .actionable-tile.filterable:hover {\n      border-color: var(--border-stronger);\n      background: var(--surface-hover);\n    }\n    .actionable-tile.filterable.active {\n      border-color: var(--text-accent);\n      box-shadow: 0 0 0 1px rgba(103, 232, 249, 0.22), var(--shadow);\n    }\n    .actionable-tile p {\n      margin: 0;\n    }\n    .actionable-tile .label {\n      color: var(--text-muted);\n      font-size: 10px;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n    .actionable-tile .value {\n      margin-top: 6px;\n      color: var(--text-primary);\n      font-size: 24px;\n      line-height: 1;\n      font-weight: 750;\n    }\n    .actionable-secondary-summary .actionable-tile {\n      padding: 10px 12px;\n      background: var(--surface-3);\n    }\n    .actionable-secondary-summary .actionable-tile .value {\n      font-size: 19px;\n    }\n    .actionable-tile .sub {\n      margin-top: 5px;\n      color: var(--text-muted);\n      font-size: 11px;\n    }\n    .wide-input {\n      width: 260px;\n    }\n    .filter-spacer {\n      flex: 1 1 auto;\n      min-width: 12px;\n    }\n    .filter-meta {\n      color: var(--text-muted);\n      font-size: 11px;\n      white-space: nowrap;\n    }\n\n    @media (max-width: 1040px) {\n      .grid-4, .grid-2, .trend-grid, .funnel-primary-metrics, .funnel-secondary-metrics, .actionable-summary, .actionable-secondary-summary {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n      }\n      .summary-strip {\n        margin-left: 0;\n      }\n      .toolbar {\n        flex-wrap: wrap;\n      }\n    }\n\n    @media (max-width: 720px) {\n      .header, .toolbar, main {\n        padding-left: 12px;\n        padding-right: 12px;\n      }\n      .header {\n        align-items: flex-start;\n        flex-direction: column;\n      }\n      .grid-4, .grid-2, .trend-grid, .funnel-primary-metrics, .funnel-secondary-metrics, .actionable-summary, .actionable-secondary-summary, .funnel {\n        grid-template-columns: 1fr;\n      }\n      .stage {\n        padding: 10px 0;\n      }\n      .stage-bridge {\n        display: none;\n      }\n      .stage-line {\n        width: 100%;\n      }\n      .legend {\n        display: none;\n      }\n      .wide-input {\n        width: 100%;\n      }\n      .month-filter,\n      .month-button {\n        width: 100%;\n      }\n      .month-menu {\n        width: min(100%, 280px);\n      }\n    }\n  ";

export const ONB_HTML = "\n  <div class=\"topbar\">\n    <header class=\"header\">\n      <div>\n        <h1 class=\"title\">Client onboarding funnel</h1>\n        <p class=\"subtitle\" id=\"dataStatus\">Loading dashboard data...</p>\n      </div>\n      <button class=\"ghost-button\" id=\"openRefresh\" type=\"button\">Refresh data</button>\n    </header>\n\n    <div class=\"toolbar\">\n      <div class=\"segmented\" id=\"statusFilter\" aria-label=\"Activation status\">\n        <button type=\"button\" data-value=\"ALL\" class=\"active\">All</button>\n        <button type=\"button\" data-value=\"ACTIVE\">Active</button>\n        <button type=\"button\" data-value=\"TRIAL\">Trial</button>\n      </div>\n      <div id=\"kamFilterMount\"></div>\n      <div class=\"month-filter\" id=\"accountMonthFilter\"></div>\n      <div class=\"summary-strip\" id=\"summaryStrip\"></div>\n    </div>\n\n    <nav class=\"tabs\" id=\"tabs\" aria-label=\"Dashboard tabs\">\n      <button type=\"button\" class=\"tab active\" data-tab=\"funnel\">Funnel</button>\n      <button type=\"button\" class=\"tab\" data-tab=\"actionables\">Actionables</button>\n      <button type=\"button\" class=\"tab\" data-tab=\"trends\">Trends</button>\n      <button type=\"button\" class=\"tab\" data-tab=\"clients\">Clients</button>\n      <button type=\"button\" class=\"tab\" data-tab=\"platforms\">Platforms</button>\n      <button type=\"button\" class=\"tab\" data-tab=\"gsts\">GSTs</button>\n    </nav>\n  </div>\n\n  <main>\n    <h2 class=\"sr-only\">ARPFlow client onboarding funnel dashboard showing activation stages and inter-stage timing metrics</h2>\n    <section id=\"funnelView\"></section>\n    <section id=\"actionablesView\" hidden></section>\n    <section id=\"trendsView\" hidden></section>\n    <section id=\"clientsView\" hidden></section>\n    <section id=\"platformsView\" hidden></section>\n    <section id=\"gstsView\" hidden></section>\n  </main>\n\n  <div class=\"modal-backdrop\" id=\"refreshModal\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"modalTitle\">\n    <div class=\"modal\">\n      <div class=\"modal-head\">\n        <h2 class=\"modal-title\" id=\"modalTitle\">Refresh dashboard data</h2>\n        <button class=\"close-button\" type=\"button\" id=\"closeRefresh\" aria-label=\"Close\">&times;</button>\n      </div>\n      <div class=\"modal-body\">\n        <p class=\"error\" id=\"loadError\"></p>\n        <div class=\"field\">\n          <label for=\"q1Input\">Q1 client summary JSON</label>\n          <textarea class=\"textarea\" id=\"q1Input\" spellcheck=\"false\"></textarea>\n        </div>\n        <div class=\"field\">\n          <label for=\"q2Input\">Q2 GST detail JSON</label>\n          <textarea class=\"textarea\" id=\"q2Input\" spellcheck=\"false\"></textarea>\n        </div>\n        <div class=\"field\">\n          <label for=\"q3Input\">Q3 platform detail JSON</label>\n          <textarea class=\"textarea\" id=\"q3Input\" spellcheck=\"false\"></textarea>\n        </div>\n        <div class=\"modal-actions\">\n          <button class=\"ghost-button\" type=\"button\" id=\"cancelRefresh\">Cancel</button>\n          <button class=\"primary-button\" type=\"button\" id=\"loadRefresh\">Load data</button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  ";

// `root` is the ShadowRoot the markup is mounted into. All original
// document.getElementById/querySelectorAll/addEventListener calls were rebound to it.
// Events are wired via addEventListener on shadow elements, so nothing leaks to window.
// `apiConfig` is { baseUrl, headers } (from src/config/backendConfig.js) or
// null/undefined — when present the live API is used, otherwise it falls back
// to the local JSON files. `defaultKam` (from the logged-in user) pre-seeds
// the KAM filter, if given.
export function initOnboarding(root, apiConfig, defaultKam) {

    // apiConfig ({ baseUrl, headers }) comes from the React wrapper's saved
    // connection (see src/utils/api.js) — null/undefined if not yet connected,
    // in which case this falls back to the local JSON files below.

    // Lifecycle guard. The React port flips this during effect cleanup so an
    // earlier async load cannot render into a newer ShadowRoot instance.
    let disposed = false;
    // Extra filters for the GST and Platform tabs (on top of the page-level
    // status / KAM / account-month filters).
    const GST_FILTER_DEFAULTS = { search: "", source: "ALL", today: "ALL", gstStatus: "ALL", uploaded: "ALL", months: "ALL", invoices: "ALL" };
    const PLATFORM_FILTER_DEFAULTS = { search: "", live: "ALL", billing: "ALL", grn: "ALL", invoices: "ALL", autoSync: "ALL", ledger: "ALL" };
    const state = {
      q1: [],
      q2: [],
      q3: [],
      status: "ALL",
      // Defaults to the logged-in KAM's own name (still fully changeable via
      // the KAM filter — "access is still complete", this is just the start).
      kams: defaultKam ? [defaultKam] : [],
      accountMonths: [],
      monthMenuOpen: false,
      tab: "funnel",
      clientSearch: "",
      actionableStages: [],
      actionableTypes: [],
      actionablePriorities: [],
      actionableAges: [],
      actionableClients: [],
      actionableOpenFilter: null,
      actionableSearch: "",
      platformFilter: "ALL",
      gstFilters: { ...GST_FILTER_DEFAULTS },
      platformFilters: { ...PLATFORM_FILTER_DEFAULTS },
      sorts: {
        clients: { col: "account_creation_date", dir: "desc" },
        platforms: { col: "account_creation_date", dir: "desc" },
        gsts: { col: "account_creation_date", dir: "desc" }
      }
    };

    const platformColors = {
      BLINKIT: ["#3f3210", "#fde68a"],
      INSTAMART: ["#3b2414", "#fdba74"],
      ZEPTO: ["#2b174e", "#d8b4fe"],
      AMAZON: ["#102a4f", "#93c5fd"],
      FLIPKART: ["#1d2554", "#a5b4fc"],
      NYKAA: ["#41152b", "#f9a8d4"]
    };

    const els = {
      dataStatus: root.getElementById("dataStatus"),
      summaryStrip: root.getElementById("summaryStrip"),
      statusFilter: root.getElementById("statusFilter"),
      kamFilterMount: root.getElementById("kamFilterMount"),
      accountMonthFilter: root.getElementById("accountMonthFilter"),
      tabs: root.getElementById("tabs"),
      funnelView: root.getElementById("funnelView"),
      actionablesView: root.getElementById("actionablesView"),
      trendsView: root.getElementById("trendsView"),
      clientsView: root.getElementById("clientsView"),
      platformsView: root.getElementById("platformsView"),
      gstsView: root.getElementById("gstsView"),
      modal: root.getElementById("refreshModal"),
      openRefresh: root.getElementById("openRefresh"),
      closeRefresh: root.getElementById("closeRefresh"),
      cancelRefresh: root.getElementById("cancelRefresh"),
      loadRefresh: root.getElementById("loadRefresh"),
      loadError: root.getElementById("loadError"),
      q1Input: root.getElementById("q1Input"),
      q2Input: root.getElementById("q2Input"),
      q3Input: root.getElementById("q3Input")
    };

    function isPresent(v) {
      return v !== null && v !== undefined && v !== "";
    }

    function median(values) {
      const nums = values.filter(isPresent).map(Number).filter(n => !Number.isNaN(n));
      if (!nums.length) return null;
      nums.sort((a, b) => a - b);
      const mid = Math.floor(nums.length / 2);
      return nums.length % 2 ? nums[mid] : Math.round((nums[mid - 1] + nums[mid]) / 2);
    }

    function parseJson(text) {
      const parsed = JSON.parse(text.trim());
      return Array.isArray(parsed) ? parsed : (Array.isArray(parsed.result) ? parsed.result : []);
    }

    function escapeHtml(value) {
      return String(value ?? "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }

    function clientLabel(row) {
      const name = row?.client_name || "-";
      const id = row?.client_uid;
      return isPresent(id) ? `${name} [${id}]` : name;
    }

    function fmtDate(iso) {
      if (!isPresent(iso)) return "";
      const date = new Date(iso);
      if (Number.isNaN(date.getTime())) return "";
      const mon = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][date.getMonth()];
      return `${String(date.getDate()).padStart(2, "0")} ${mon} '${String(date.getFullYear()).slice(2)}`;
    }

    function monthKey(iso) {
      if (!isPresent(iso)) return "";
      const date = new Date(iso);
      if (Number.isNaN(date.getTime())) return "";
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    }

    function monthLabel(key) {
      if (!key) return "";
      const [year, month] = key.split("-").map(Number);
      if (!year || !month) return key;
      const mon = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][month - 1];
      return `${mon} '${String(year).slice(2)}`;
    }

    function accountMonthOptions() {
      return [...new Set(state.q1.map(row => monthKey(row.account_creation_date)).filter(Boolean))].sort().reverse();
    }

    function sortRows(rows, sort) {
      return [...rows].sort((a, b) => {
        const av = a[sort.col];
        const bv = b[sort.col];
        if (!isPresent(av) && !isPresent(bv)) return 0;
        if (!isPresent(av)) return 1;
        if (!isPresent(bv)) return -1;
        const an = Number(av);
        const bn = Number(bv);
        const cmp = !Number.isNaN(an) && !Number.isNaN(bn)
          ? an - bn
          : String(av).localeCompare(String(bv), undefined, { sensitivity: "base" });
        return sort.dir === "asc" ? cmp : -cmp;
      });
    }

    function filteredQ1() {
      const selectedMonths = new Set(state.accountMonths);
      return state.q1.filter(row =>
        (state.status === "ALL" || row.activation_status === state.status) &&
        (!state.kams.length || state.kams.includes(row.kam_name)) &&
        (!selectedMonths.size || selectedMonths.has(monthKey(row.account_creation_date)))
      );
    }

    function uidSet(rows) {
      return new Set(rows.map(row => String(row.client_uid)));
    }

    function startOfDay(date) {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    }

    function daysSince(iso) {
      if (!isPresent(iso)) return null;
      const start = startOfDay(iso);
      if (Number.isNaN(start.getTime())) return null;
      const today = startOfDay(new Date());
      return Math.max(0, Math.floor((today - start) / 86400000));
    }

    function ageBucket(days) {
      if (days === null || days === undefined) return "Unknown";
      if (days <= 7) return "0-7d";
      if (days <= 14) return "8-14d";
      if (days <= 30) return "15-30d";
      return "31d+";
    }

    function classForDays(value, good, warn) {
      if (!isPresent(value)) return "muted";
      const num = Number(value);
      if (num < 0) return "pro";
      if (num <= good) return "success";
      if (num <= warn) return "warning";
      return "danger";
    }

    function dayChip(value, good, warn) {
      if (!isPresent(value)) return `<span class="muted">-</span>`;
      const cls = classForDays(value, good, warn);
      const styles = {
        pro: ["var(--bg-pro)", "var(--text-pro)"],
        success: ["var(--bg-success)", "var(--text-success)"],
        warning: ["var(--bg-warning)", "var(--text-warning)"],
        danger: ["var(--bg-danger)", "var(--text-danger)"]
      }[cls];
      const num = Number(value);
      const label = num >= 0 ? `+${num}d` : `${num}d`;
      return `<span class="day-chip" style="background:${styles[0]};color:${styles[1]}">${label}</span>`;
    }

    function statusBadge(value) {
      const active = value === "ACTIVE";
      const trial = value === "TRIAL";
      const bg = active ? "var(--bg-success)" : trial ? "var(--bg-warning)" : "var(--surface-1)";
      const color = active ? "var(--text-success)" : trial ? "var(--text-warning)" : "var(--text-muted)";
      return `<span class="badge" style="background:${bg};color:${color}">${escapeHtml(value || "-")}</span>`;
    }

    function platformBadge(value) {
      const colors = platformColors[value] || ["var(--surface-1)", "var(--text-secondary)"];
      return `<span class="badge" style="background:${colors[0]};color:${colors[1]}">${escapeHtml(value || "-")}</span>`;
    }

    function platformShort(value) {
      return {
        BLINKIT: "BL",
        INSTAMART: "IM",
        ZEPTO: "ZP",
        AMAZON: "AM",
        FLIPKART: "FK",
        NYKAA: "NY"
      }[value] || String(value || "-").slice(0, 2).toUpperCase();
    }

    function platformIsLive(row) {
      if (!row) return false;
      return String(row.platform_status || "").toLowerCase() === "live" ||
        isPresent(row.first_successful_grn_upload_at) ||
        isPresent(row.days_creation_to_platform_live);
    }

    function platformIndicator(platform, row) {
      const live = platformIsLive(row);
      const colors = platformColors[platform] || ["var(--surface-1)", "var(--text-secondary)"];
      const label = platformShort(platform);
      const title = `${platform}: ${live ? "Live" : "Not live"}`;
      return `
        <span class="mini-status ${live ? "live" : "missing"}" title="${escapeHtml(title)}">
          <span class="platform-dot" style="background:${colors[1]}"></span>
          <span>${escapeHtml(label)}</span>
          <span class="status-mark">${live ? "&#10003;" : "&times;"}</span>
        </span>
      `;
    }

    function platformSummary(clientUid, platforms) {
      const rows = state.q3.filter(row => String(row.client_uid) === String(clientUid));
      const byPlatform = new Map(rows.map(row => [row.platform_name, row]));
      return `
        <div class="status-cluster">
          ${platforms.map(platform => platformIndicator(platform, byPlatform.get(platform))).join("")}
        </div>
      `;
    }

    function actionIndicator(label, done) {
      return `
        <span class="mini-status ${done ? "done" : "missing"}" title="${escapeHtml(label)}: ${done ? "Activity recorded" : "No activity"}">
          <span>${escapeHtml(label)}</span>
          <span class="status-mark">${done ? "&#10003;" : "&times;"}</span>
        </span>
      `;
    }

    function actionSummary(row) {
      const actions = [
        ["GRN Missing", "first_grn_missing_action_at"],
        ["GRN Short", "first_grn_short_action_at"],
        ["Rejected Inv", "first_rejected_invoice_action_at"],
        ["Pay Overdue", "first_payment_overdue_action_at"]
      ];
      return `
        <div class="status-cluster">
          ${actions.map(([label, field]) => actionIndicator(label, isPresent(row[field]))).join("")}
        </div>
      `;
    }

    function booleanIndicator(label, done) {
      return actionIndicator(label, done);
    }

    function buildActionables(baseRows) {
      const clientIds = uidSet(baseRows);
      const q2ByClient = new Map();
      const q3ByClient = new Map();
      for (const row of state.q2) {
        // Rows without a saved login (manual uploads / no data) are not "pending portal uploads".
        if (!gstHasLogin(row)) continue;
        const key = String(row.client_uid);
        if (!q2ByClient.has(key)) q2ByClient.set(key, []);
        q2ByClient.get(key).push(row);
      }
      for (const row of state.q3) {
        const key = String(row.client_uid);
        if (!q3ByClient.has(key)) q3ByClient.set(key, []);
        q3ByClient.get(key).push(row);
      }

      const rows = [];
      function add(client, movement, type, detail, stuckFrom, priority = "Open") {
        rows.push({
          client_uid: client.client_uid,
          client_name: client.client_name,
          activation_status: client.activation_status,
          kam_name: client.kam_name,
          account_creation_date: client.account_creation_date,
          movement,
          type,
          detail,
          stuck_from: stuckFrom,
          stuck_days: daysSince(stuckFrom),
          age_bucket: ageBucket(daysSince(stuckFrom)),
          priority
        });
      }

      for (const client of baseRows) {
        const id = String(client.client_uid);
        if (!clientIds.has(id)) continue;
        const gstRows = q2ByClient.get(id) || [];
        const platformRows = q3ByClient.get(id) || [];
        const hasAnyGstUpload = isPresent(client.gst_earliest_first_upload) || gstRows.some(row => isPresent(row.first_successful_upload_at));
        const hasAnyPlatformLive = isPresent(client.platform_earliest_first_upload) || platformRows.some(platformIsLive);

        if (!isPresent(client.dashboard_live_at)) {
          if (!hasAnyGstUpload) {
            add(client, "Create -> Dashboard Live", "GST Upload at least 1 time", "No GST has a successful upload yet", client.account_creation_date, "Blocking");
          }
          if (!hasAnyPlatformLive) {
            add(client, "Create -> Dashboard Live", "Any 1 platform Live", "No platform is live yet", client.account_creation_date, "Blocking");
          }
        }

        if (isPresent(client.dashboard_live_at) && !isPresent(client.kickoff_date) && client.activation_status !== "TRIAL") {
          add(client, "Dashboard Live -> KO Date", "Kickoff Call to be done", "Kickoff date is not recorded", client.dashboard_live_at, "Blocking");
        }

        if (!isPresent(client.full_dashboard_live_at)) {
          const pendingGsts = gstRows.filter(row => !isPresent(row.first_successful_upload_at));
          const pendingPlatforms = platformRows.filter(row => !platformIsLive(row));
          for (const gst of pendingGsts) {
            add(client, "Created -> Full Dashboard Live", "Pending GST upload", gst.gst_number || "GST upload pending", client.account_creation_date, "Open");
          }
          for (const platform of pendingPlatforms) {
            add(client, "Created -> Full Dashboard Live", "Pending platform upload", platform.platform_name || "Platform upload pending", client.account_creation_date, "Open");
          }
        }

        if (isPresent(client.dashboard_live_at)) {
          if (!isPresent(client.first_any_ticket_action_at)) {
            add(client, "Dashboard Live -> 1st Activity", "First activity on any ticket type pending", "No activity recorded on any issue type", client.dashboard_live_at, "Blocking");
          }
          const actionTypes = [
            ["GRN Missing", "first_grn_missing_action_at"],
            ["GRN Short", "first_grn_short_action_at"],
            ["Rejected Invoice", "first_rejected_invoice_action_at"],
            ["Payment Overdue", "first_payment_overdue_action_at"]
          ];
          for (const [label, field] of actionTypes) {
            if (!isPresent(client[field])) {
              add(client, "Dashboard Live -> 1st Activity", `${label} activity pending`, "No first action recorded", client.dashboard_live_at, "Open");
            }
          }
        }
      }
      return sortRows(rows, { col: "account_creation_date", dir: "desc" });
    }

    function sortableTh(label, table, col) {
      const sort = state.sorts[table];
      const mark = sort.col === col ? (sort.dir === "asc" ? "&uarr;" : "&darr;") : "&#8597;";
      return `<th>${label}${sort.col === col ? ` <span class="muted">${mark}</span>` : ""}</th>`;
    }

    function metricCard(label, sublabel, values, total, good, warn) {
      const med = median(values);
      const reached = values.filter(isPresent).length;
      const pct = total > 0 ? Math.round((reached / total) * 100) : 0;
      const color = !isPresent(med) ? "var(--text-muted)" :
        Number(med) < 0 ? "var(--text-pro)" :
        Number(med) <= good ? "var(--text-success)" :
        Number(med) <= warn ? "var(--text-warning)" : "var(--text-danger)";
      const bar = pct >= 70 ? "var(--fill-success)" : pct >= 40 ? "var(--fill-warning)" : "var(--border-stronger)";
      return `
        <article class="metric-card">
          <p class="metric-label">${label}</p>
          <p class="metric-sub">${sublabel || ""}</p>
          <p class="metric-value" style="color:${color}">${isPresent(med) ? med : "-"}<span>days median</span></p>
          <div class="bar"><span style="width:${pct}%;background:${bar}"></span></div>
          <p class="metric-foot"><b>${reached}</b> of ${total} clients reached - ${pct}%</p>
        </article>
      `;
    }

    const trendSeries = [
      { key: "days_creation_to_dashboard_live", label: "Created -> Dashboard Live", color: "#38bdf8" },
      { key: "days_dashboard_live_to_kickoff", label: "Dashboard Live -> Kickoff", color: "#f59e0b" },
      { key: "days_dashboard_live_to_first_action", label: "Dashboard Live -> 1st Activity", color: "#a78bfa" },
      { key: "days_creation_to_full_dashboard_live", label: "Created -> Full Dashboard Live", color: "#22c55e" }
    ];

    const issueActivityActionTypes = [
      "GRN Missing activity pending",
      "GRN Short activity pending",
      "Rejected Invoice activity pending",
      "Payment Overdue activity pending"
    ];

    const actionableBuckets = [
      { value: "Create -> Dashboard Live", label: "Created -> Dashboard Live TAT", color: "#38bdf8" },
      { value: "Dashboard Live -> KO Date", label: "Dashboard Live -> Kickoff TAT", color: "#f59e0b" },
      { value: "Created -> Full Dashboard Live", label: "Created -> Full Dashboard Live TAT", color: "#22c55e" },
      { value: "Dashboard Live -> 1st Activity", label: "Dashboard Live -> 1st Activity TAT", color: "#a78bfa" }
    ];

    const primaryActionableCards = [
      { value: "Create -> Dashboard Live", label: "Created -> Dashboard Live TAT", color: "#38bdf8" },
      { value: "Dashboard Live -> KO Date", label: "Dashboard Live -> Kickoff TAT", color: "#f59e0b" },
      { value: "Dashboard Live -> 1st Activity", label: "Dashboard Live -> 1st Activity TAT", color: "#a78bfa", cardTypes: ["First activity on any ticket type pending"] }
    ];

    const secondaryActionableCards = [
      { value: "Created -> Full Dashboard Live", label: "Created -> Full Dashboard Live TAT", color: "#22c55e" },
      { value: "Dashboard Live -> 1st Activity", label: "Dashboard Live -> All Issue Activity", color: "#c084fc", cardTypes: issueActivityActionTypes }
    ];

    function bucketLabel(value) {
      return actionableBuckets.find(bucket => bucket.value === value)?.label || value;
    }

    function validSelection(selected, validValues) {
      const valid = new Set(validValues);
      return selected.filter(value => valid.has(value));
    }

    function multiFilterControl(id, buttonLabel, allLabel, options, selected) {
      const selectedSet = new Set(selected);
      const selectedLabels = options
        .filter(option => selectedSet.has(option.value))
        .map(option => option.label);
      const label = selectedLabels.length
        ? `${selectedLabels.length} ${buttonLabel}${selectedLabels.length > 1 ? "s" : ""}: ${selectedLabels.slice(0, 2).join(", ")}${selectedLabels.length > 2 ? "..." : ""}`
        : allLabel;
      return `
        <div class="month-filter ${state.actionableOpenFilter === id ? "open" : ""}" data-actionable-filter="${escapeHtml(id)}">
          <button class="month-button" type="button" aria-haspopup="true" aria-expanded="${state.actionableOpenFilter === id ? "true" : "false"}">
            <span>${escapeHtml(label)}</span>
            <span class="muted">${state.actionableOpenFilter === id ? "&#9652;" : "&#9662;"}</span>
          </button>
          <div class="month-menu" role="menu" aria-label="${escapeHtml(allLabel)}">
            <div class="month-menu-actions">
              <button type="button" data-actionable-filter-action="all">All</button>
              <button type="button" data-actionable-filter-action="clear">Clear</button>
            </div>
            ${options.map(option => `
              <label class="month-option">
                <input type="checkbox" value="${escapeHtml(option.value)}" ${selectedSet.has(option.value) ? "checked" : ""}>
                <span>${escapeHtml(option.label)} (${option.count || 0})</span>
              </label>
            `).join("") || `<span class="month-option muted">No options</span>`}
          </div>
        </div>
      `;
    }

    function getActionableFilterValues(id) {
      return {
        stage: state.actionableStages,
        type: state.actionableTypes,
        priority: state.actionablePriorities,
        age: state.actionableAges,
        client: state.actionableClients
      }[id] || [];
    }

    function setActionableFilterValues(id, values) {
      if (id === "stage") state.actionableStages = values;
      if (id === "type") state.actionableTypes = values;
      if (id === "priority") state.actionablePriorities = values;
      if (id === "age") state.actionableAges = values;
      if (id === "client") state.actionableClients = values;
    }

    function chartValue(value) {
      if (!isPresent(value)) return null;
      const num = Number(value);
      return Number.isNaN(num) ? null : num;
    }

    function buildTrendChart(rows, series) {
      const chartRows = rows
        .map(row => ({ ...row, createdMs: new Date(row.account_creation_date).getTime() }))
        .filter(row => Number.isFinite(row.createdMs))
        .sort((a, b) => a.createdMs - b.createdMs);
      const points = chartRows
        .map(row => {
          const value = chartValue(row[series.key]);
          return value === null ? null : { row, value };
        })
        .filter(Boolean);
      const values = points.map(point => point.value);
      if (!chartRows.length || !values.length) {
        return `<div class="empty"><h3>No trend data</h3><p>The selected filters do not have values for this metric.</p></div>`;
      }

      const width = 620;
      const height = 330;
      const margin = { top: 24, right: 22, bottom: 48, left: 54 };
      const plotW = width - margin.left - margin.right;
      const plotH = height - margin.top - margin.bottom;
      let minTime = Math.min(...chartRows.map(row => row.createdMs));
      let maxTime = Math.max(...chartRows.map(row => row.createdMs));
      if (minTime === maxTime) maxTime += 86400000;
      const rawMin = Math.min(0, ...values);
      const rawMax = Math.max(...values);
      const pad = Math.max(5, Math.round((rawMax - rawMin) * 0.12));
      const yMin = Math.floor((rawMin - pad) / 10) * 10;
      const yMax = Math.max(10, Math.ceil((rawMax + pad) / 10) * 10);
      const x = time => margin.left + ((time - minTime) / (maxTime - minTime)) * plotW;
      const y = value => margin.top + ((yMax - value) / (yMax - yMin)) * plotH;
      const yTicks = Array.from({ length: 6 }, (_, i) => Math.round(yMin + ((yMax - yMin) * i) / 5));
      const xTicks = Array.from({ length: 4 }, (_, i) => minTime + ((maxTime - minTime) * i) / 3);
      const positioned = points.map(point => ({
        ...point,
        x: x(point.row.createdMs),
        y: y(point.value)
      }));
      const path = positioned.map((point, i) => `${i === 0 ? "M" : "L"} ${point.x.toFixed(1)} ${point.y.toFixed(1)}`).join(" ");

      return `
        <svg class="trend-chart" viewBox="0 0 ${width} ${height}" role="img" aria-label="${escapeHtml(series.label)} over account creation date">
          <rect x="0" y="0" width="${width}" height="${height}" fill="transparent"></rect>
          ${yTicks.map(tick => `
            <line class="grid-line" x1="${margin.left}" x2="${width - margin.right}" y1="${y(tick).toFixed(1)}" y2="${y(tick).toFixed(1)}"></line>
            <text x="${margin.left - 12}" y="${(y(tick) + 4).toFixed(1)}" text-anchor="end">${tick}d</text>
          `).join("")}
          ${xTicks.map(tick => `
            <line class="grid-line" x1="${x(tick).toFixed(1)}" x2="${x(tick).toFixed(1)}" y1="${margin.top}" y2="${height - margin.bottom}" opacity="0.45"></line>
            <text x="${x(tick).toFixed(1)}" y="${height - 18}" text-anchor="middle">${fmtDate(new Date(tick).toISOString())}</text>
          `).join("")}
          <line class="axis-line" x1="${margin.left}" x2="${width - margin.right}" y1="${height - margin.bottom}" y2="${height - margin.bottom}"></line>
          <line class="axis-line" x1="${margin.left}" x2="${margin.left}" y1="${margin.top}" y2="${height - margin.bottom}"></line>
          <text x="${margin.left}" y="16">Days</text>
          <text x="${width - margin.right}" y="${height - 4}" text-anchor="end">Account creation date</text>
          ${positioned.length > 1 ? `<path class="series-line" d="${path}" stroke="${series.color}"></path>` : ""}
          ${positioned.map(point => `
            <circle class="series-point" cx="${point.x.toFixed(1)}" cy="${point.y.toFixed(1)}" r="4" fill="${series.color}">
              <title>${escapeHtml(clientLabel(point.row))} - ${fmtDate(point.row.account_creation_date)} - ${series.label}: ${point.value} days</title>
            </circle>
          `).join("")}
        </svg>
      `;
    }

    function renderTrends() {
      const rows = filteredQ1();
      const m = metrics(rows);
      els.trendsView.innerHTML = `
        <div class="grid-4">
          ${metricCard("Created -> Dashboard Live", "Median for selected clients", m.values.creToLive, m.counts.total, 7, 14)}
          ${metricCard("Dashboard Live -> Kickoff", "Median for dashboard-live clients", m.values.liveToKO, m.counts.dl, 7, 14)}
          ${metricCard("Dashboard Live -> 1st Activity", "Median for dashboard-live clients", m.values.liveToAct, m.counts.dl, 21, 45)}
          ${metricCard("Created -> Full Dashboard Live", "Median for selected clients", m.values.creToFull, m.counts.total, 14, 30)}
        </div>
        <div class="trend-grid">
          ${trendSeries.map(series => `
            <div class="panel chart-panel">
              <div class="panel-head">
                <p class="panel-title"><span class="legend-swatch" style="display:inline-block;background:${series.color};margin-right:6px"></span>${series.label}</p>
                <p class="panel-subtitle">X-axis = account creation date, Y-axis = days. Points are clients matching the current filters.</p>
              </div>
              <div class="chart-wrap">${buildTrendChart(rows, series)}</div>
            </div>
          `).join("")}
        </div>
      `;
    }

    function metrics(rows) {
      const withDashboard = rows.filter(row => isPresent(row.dashboard_live_at));
      const allIssueActivityDays = row => {
        const vals = [
          row.days_dashboard_live_to_grn_missing,
          row.days_dashboard_live_to_grn_short,
          row.days_dashboard_live_to_rejected_invoice,
          row.days_dashboard_live_to_payment_overdue
        ];
        if (!vals.every(isPresent)) return null;
        const nums = vals.map(Number).filter(num => !Number.isNaN(num));
        return nums.length === vals.length ? Math.max(...nums) : null;
      };
      const counts = {
        total: rows.length,
        dl: rows.filter(row => isPresent(row.dashboard_live_at)).length,
        ko: rows.filter(row => isPresent(row.kickoff_date)).length,
        act: rows.filter(row => isPresent(row.first_any_ticket_action_at)).length,
        full: rows.filter(row => isPresent(row.full_dashboard_live_at)).length
      };
      return {
        counts,
        withDashboard,
        values: {
          creToLive: rows.map(row => row.days_creation_to_dashboard_live),
          liveToKO: withDashboard.map(row => row.days_dashboard_live_to_kickoff),
          liveToAct: withDashboard.map(row => row.days_dashboard_live_to_first_action),
          creToFull: rows.map(row => row.days_creation_to_full_dashboard_live),
          liveToG1: withDashboard.map(row => row.days_dashboard_live_to_grn_missing),
          liveToG2: withDashboard.map(row => row.days_dashboard_live_to_grn_short),
          liveToRI: withDashboard.map(row => row.days_dashboard_live_to_rejected_invoice),
          liveToOD: withDashboard.map(row => row.days_dashboard_live_to_payment_overdue),
          liveToAllIssueAct: withDashboard.map(allIssueActivityDays)
        }
      };
    }

    function renderHeader() {
      renderAccountMonthFilter();
      const rows = filteredQ1();
      const m = metrics(rows);
      const actionableCount = buildActionables(rows).length;
      els.summaryStrip.innerHTML = `
        <span><b>${m.counts.total}</b> clients</span>
        <span><b>${m.counts.dl}</b> dashboard live</span>
        <span><b>${m.counts.ko}</b> kicked off</span>
        <span><b>${m.counts.act}</b> took action</span>
        <span><b>${actionableCount}</b> actionables</span>
      `;

      const kams = [...new Set(state.q1.map(row => row.kam_name).filter(isPresent))].sort();
      state.kams = state.kams.filter(kam => kams.includes(kam));
      window.renderOnboardingKamFilter?.({ options: kams, selected: state.kams, onChange: values => { state.kams = values; render(); } });

      els.tabs.querySelector('[data-tab="clients"]').textContent = `Clients (${rows.length})`;
      els.tabs.querySelector('[data-tab="actionables"]').textContent = `Actionables (${actionableCount})`;
      const ids = uidSet(rows);
      const platformCount = state.q3.filter(row => ids.has(String(row.client_uid)) && (state.platformFilter === "ALL" || row.platform_name === state.platformFilter)).length;
      const gstCount = state.q2.filter(row => ids.has(String(row.client_uid))).length;
      els.tabs.querySelector('[data-tab="platforms"]').textContent = `Platforms (${platformCount})`;
      els.tabs.querySelector('[data-tab="gsts"]').textContent = `GSTs (${gstCount})`;
    }

    function renderAccountMonthFilter() {
      const months = accountMonthOptions();
      const valid = new Set(months);
      state.accountMonths = state.accountMonths.filter(month => valid.has(month));
      const selected = new Set(state.accountMonths);
      const label = selected.size
        ? `${selected.size} month${selected.size > 1 ? "s" : ""}: ${state.accountMonths.map(monthLabel).slice(0, 2).join(", ")}${selected.size > 2 ? "..." : ""}`
        : "All creation months";
      els.accountMonthFilter.className = `month-filter${state.monthMenuOpen ? " open" : ""}`;
      els.accountMonthFilter.innerHTML = `
        <button class="month-button" type="button" id="monthFilterToggle" aria-haspopup="true" aria-expanded="${state.monthMenuOpen ? "true" : "false"}">
          <span>${escapeHtml(label)}</span>
          <span class="muted">${state.monthMenuOpen ? "&#9652;" : "&#9662;"}</span>
        </button>
        <div class="month-menu" role="menu" aria-label="Account creation month filter">
          <div class="month-menu-actions">
            <button type="button" data-month-action="all">All months</button>
            <button type="button" data-month-action="clear">Clear</button>
          </div>
          ${months.map(month => `
            <label class="month-option">
              <input type="checkbox" value="${escapeHtml(month)}" ${selected.has(month) ? "checked" : ""}>
              <span>${escapeHtml(monthLabel(month))}</span>
            </label>
          `).join("") || `<span class="month-option muted">No account creation dates</span>`}
        </div>
      `;
    }

    function renderFunnel() {
      const rows = filteredQ1();
      const ids = uidSet(rows);
      const m = metrics(rows);
      const counts = m.counts;
      const stages = [
        { label: "Account created", n: counts.total, color: "var(--fill-accent)" },
        { label: "1st dashboard live", n: counts.dl, color: "var(--fill-success)" },
        { label: "Kickoff done", n: counts.ko, color: "var(--fill-warning)" },
        { label: "First ticket action", n: counts.act, color: "var(--fill-pro)" }
      ];

      const fq3 = state.q3.filter(row => ids.has(String(row.client_uid)));
      const platformMetrics = ["BLINKIT", "INSTAMART", "ZEPTO", "AMAZON", "FLIPKART", "NYKAA"]
        .map(platform => {
          const platformRows = fq3.filter(row => row.platform_name === platform);
          const vals = platformRows.map(row => row.days_creation_to_platform_live);
          return {
            platform,
            median: median(vals),
            reached: vals.filter(isPresent).length,
            total: platformRows.length
          };
        })
        .filter(row => row.total > 0);

      const anomalyRows = rows.filter(row => Number(row.days_dashboard_live_to_kickoff) < 0);
      const anomalyNote = anomalyRows.length
        ? `<p class="note">Data anomaly: ${escapeHtml(anomalyRows.map(row => `${clientLabel(row)} live-to-kickoff ${row.days_dashboard_live_to_kickoff}d`).join(", "))}. Negative gaps remain included in medians.</p>`
        : "";

      els.funnelView.innerHTML = `
        <div class="panel funnel-panel">
          <p class="section-label">Activation stages</p>
          <div class="funnel">
            ${stages.map((stage, i) => {
              const pctPrev = i === 0 ? 100 : stages[i - 1].n > 0 ? Math.round((stage.n / stages[i - 1].n) * 100) : 0;
              const pctTotal = stages[0].n > 0 ? Math.round((stage.n / stages[0].n) * 100) : 0;
              const opacity = 0.15 + 0.85 * (pctTotal / 100);
              return `
                <div class="stage">
                  ${i > 0 ? `<div class="stage-bridge">&rarr; ${pctPrev}%</div>` : ""}
                  <div class="stage-line" style="background:${stage.color};opacity:${opacity}"></div>
                  <div class="stage-count">${stage.n}</div>
                  <div class="stage-label">${stage.label}</div>
                  ${i > 0 ? `<div class="stage-pct">${pctTotal}% of total</div>` : ""}
                </div>
              `;
            }).join("")}
          </div>
        </div>

        <p class="section-label">Core funnel gaps - median</p>
        <div class="funnel-primary-metrics">
          ${metricCard("Account creation &rarr; 1st dashboard live", "GST + platform must both have 1st upload", m.values.creToLive, counts.total, 7, 14)}
          ${metricCard("1st dashboard live &rarr; kickoff", "Among clients with dashboard live", m.values.liveToKO, counts.dl, 7, 14)}
          ${metricCard("1st dashboard live &rarr; 1st ticket action", "Any issue type, any external user", m.values.liveToAct, counts.dl, 21, 45)}
        </div>

        <p class="section-label">Full activation depth - median</p>
        <div class="funnel-secondary-metrics">
          ${metricCard("Account creation &rarr; full dashboard live", "All GSTs + all platforms uploaded", m.values.creToFull, counts.total, 14, 30)}
          ${metricCard("Dashboard live &rarr; all issue activity", "All four issue types have 1st activity", m.values.liveToAllIssueAct, counts.dl, 21, 45)}
        </div>

        <div class="grid-2">
          <div class="panel table-shell">
            <div class="panel-head">
              <p class="panel-title">Account creation &rarr; platform live</p>
              <p class="panel-subtitle">Median days to first GRN upload per platform</p>
            </div>
            <div class="table-wrap">
              <table>
                <thead><tr><th>Platform</th><th style="text-align:center">Median</th><th style="text-align:center">Live</th><th style="text-align:center">Total</th><th>Coverage</th></tr></thead>
                <tbody>
                  ${platformMetrics.map(row => {
                    const pct = row.total > 0 ? Math.round((row.reached / row.total) * 100) : 0;
                    return `
                      <tr>
                        <td>${platformBadge(row.platform)}</td>
                        <td style="text-align:center">${dayChip(row.median, 7, 14)}</td>
                        <td class="strong" style="text-align:center">${row.reached}</td>
                        <td class="secondary" style="text-align:center">${row.total}</td>
                        <td>
                          <div style="display:flex;align-items:center;gap:7px;min-width:120px">
                            <div class="bar" style="margin:0;flex:1"><span style="width:${pct}%;background:var(--fill-accent)"></span></div>
                            <span class="muted" style="min-width:30px;text-align:right;font-size:10px">${pct}%</span>
                          </div>
                        </td>
                      </tr>
                    `;
                  }).join("")}
                </tbody>
              </table>
            </div>
          </div>

          <div class="panel table-shell">
            <div class="panel-head">
              <p class="panel-title">Dashboard live &rarr; first action by issue type</p>
              <p class="panel-subtitle">Median days, base = clients with dashboard live (${counts.dl})</p>
            </div>
            <div class="table-wrap">
              <table>
                <thead><tr><th>Issue type</th><th style="text-align:center">Median</th><th style="text-align:center">Acted</th><th style="text-align:center">% of DL clients</th></tr></thead>
                <tbody>
                  ${[
                    ["GRN Missing", m.values.liveToG1],
                    ["GRN Short", m.values.liveToG2],
                    ["Rejected Invoice", m.values.liveToRI],
                    ["Payment Overdue", m.values.liveToOD]
                  ].map(([label, vals]) => {
                    const med = median(vals);
                    const reached = vals.filter(isPresent).length;
                    const pct = counts.dl > 0 ? `${Math.round((reached / counts.dl) * 100)}%` : "-";
                    return `
                      <tr>
                        <td class="strong">${label}</td>
                        <td style="text-align:center">${dayChip(med, 21, 45)}</td>
                        <td class="strong" style="text-align:center">${reached}</td>
                        <td class="secondary" style="text-align:center">${pct}</td>
                      </tr>
                    `;
                  }).join("")}
                </tbody>
              </table>
            </div>
            ${anomalyNote}
          </div>
        </div>
      `;
    }

    function renderActionables() {
      const allRows = buildActionables(filteredQ1());
      const movements = actionableBuckets.map(bucket => bucket.value);
      const types = [...new Set(allRows.map(row => row.type))].sort();
      const priorities = [...new Set(allRows.map(row => row.priority))].sort();
      const clientOptions = [...new Map(allRows.map(row => [String(row.client_uid), row])).values()]
        .sort((a, b) => clientLabel(a).localeCompare(clientLabel(b), undefined, { sensitivity: "base" }))
        .map(row => ({ value: String(row.client_uid), label: clientLabel(row) }));
      const countBy = (rows, field) => rows.reduce((acc, row) => {
        acc[row[field]] = (acc[row[field]] || 0) + 1;
        return acc;
      }, {});
      const movementCounts = countBy(allRows, "movement");
      const priorityCounts = countBy(allRows, "priority");
      const ageCounts = countBy(allRows, "age_bucket");
      const clientCounts = countBy(allRows.map(row => ({ client_uid: String(row.client_uid) })), "client_uid");
      const ages = ["0-7d", "8-14d", "15-30d", "31d+"];
      const activeStages = validSelection(state.actionableStages, movements);
      const activeStageSet = new Set(activeStages);
      state.actionableStages = activeStages;
      const typeBase = activeStages.length ? allRows.filter(row => activeStageSet.has(row.movement)) : allRows;
      const typeCounts = countBy(typeBase, "type");
      const activeTypes = validSelection(state.actionableTypes, types);
      const activePriorities = validSelection(state.actionablePriorities, priorities);
      const activeAges = validSelection(state.actionableAges, ages);
      const activeClients = validSelection(state.actionableClients, clientOptions.map(option => option.value));
      state.actionableTypes = activeTypes;
      state.actionablePriorities = activePriorities;
      state.actionableAges = activeAges;
      state.actionableClients = activeClients;
      const activeTypeSet = new Set(activeTypes);
      const activePrioritySet = new Set(activePriorities);
      const activeAgeSet = new Set(activeAges);
      const activeClientSet = new Set(activeClients);
      const filtered = allRows.filter(row =>
        (!activeStageSet.size || activeStageSet.has(row.movement)) &&
        (!activeTypeSet.size || activeTypeSet.has(row.type)) &&
        (!activePrioritySet.size || activePrioritySet.has(row.priority)) &&
        (!activeAgeSet.size || activeAgeSet.has(row.age_bucket)) &&
        (!activeClientSet.size || activeClientSet.has(String(row.client_uid))) &&
        (!state.actionableSearch ||
          `${clientLabel(row)} ${row.type} ${row.detail} ${row.movement} ${row.kam_name || ""}`.toLowerCase().includes(state.actionableSearch.toLowerCase()))
      );
      const filtersActive = activeStages.length || activeTypes.length || activePriorities.length || activeAges.length || activeClients.length || Boolean(state.actionableSearch);
      const blocking = filtered.filter(row => row.priority === "Blocking").length;
      const cardStats = card => {
        const cardTypeSet = new Set(card.cardTypes || []);
        const rows = allRows.filter(row => row.movement === card.value && (!cardTypeSet.size || cardTypeSet.has(row.type)));
        return {
          ...card,
          actionables: rows.length,
          clients: new Set(rows.map(row => String(row.client_uid))).size,
          stuck31: rows.filter(row => Number(row.stuck_days) > 30).length
        };
      };
      const primaryStats = primaryActionableCards.map(cardStats);
      const secondaryStats = secondaryActionableCards.map(cardStats);
      const renderActionableCard = card => {
        const cardTypes = card.cardTypes || [];
        const cardActive = activeStageSet.has(card.value) && (!cardTypes.length || cardTypes.every(type => activeTypeSet.has(type)));
        return `
          <button class="actionable-tile filterable ${cardActive ? "active" : ""}" type="button" aria-pressed="${cardActive ? "true" : "false"}" data-actionable-bucket="${escapeHtml(card.value)}" data-actionable-card-types="${escapeHtml(cardTypes.join("||"))}">
            <p class="label"><span class="legend-swatch" style="display:inline-block;background:${card.color};margin-right:6px"></span>${escapeHtml(card.label)}</p>
            <p class="value">${card.actionables}</p>
            <p class="sub">${card.clients} client${card.clients === 1 ? "" : "s"} impacted${card.stuck31 ? ` - ${card.stuck31} stuck 31d+` : ""}</p>
          </button>
        `;
      };

      els.actionablesView.innerHTML = `
        <div class="actionable-summary">
          ${primaryStats.map(renderActionableCard).join("")}
        </div>
        <div class="actionable-secondary-summary">
          ${secondaryStats.map(renderActionableCard).join("")}
        </div>
        <div class="panel table-shell">
          <div class="table-tools">
            ${multiFilterControl("stage", "bucket", `All TAT buckets (${allRows.length})`, actionableBuckets.map(bucket => ({ value: bucket.value, label: bucket.label, count: movementCounts[bucket.value] || 0 })), activeStages)}
            ${multiFilterControl("type", "type", `All action types (${typeBase.length})`, types.map(value => ({ value, label: value, count: typeCounts[value] || 0 })), activeTypes)}
            ${multiFilterControl("priority", "priority", `All priorities (${allRows.length})`, priorities.map(value => ({ value, label: value, count: priorityCounts[value] || 0 })), activePriorities)}
            ${multiFilterControl("age", "age bucket", `All stuck ages (${allRows.length})`, ages.map(value => ({ value, label: value, count: ageCounts[value] || 0 })), activeAges)}
            ${multiFilterControl("client", "client", `All clients (${clientOptions.length})`, clientOptions.map(option => ({ ...option, count: clientCounts[option.value] || 0 })), activeClients)}
            <input class="input wide-input" id="actionableSearch" type="search" placeholder="Search client/action/detail" value="${escapeHtml(state.actionableSearch)}">
            <span class="filter-spacer"></span>
            <span class="filter-meta">Showing ${filtered.length} of ${allRows.length}</span>
            <button class="ghost-button" type="button" id="actionableReset" ${filtersActive ? "" : "disabled"}>Reset</button>
          </div>
          <div class="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Client</th>
                  <th>Status</th>
                  <th>KAM</th>
                  <th>Created &darr;</th>
                  <th>TAT bucket</th>
                  <th>Pending actionable</th>
                  <th>Detail</th>
                  <th>Stuck from</th>
                  <th>Stuck days</th>
                  <th>Age</th>
                  <th>Priority</th>
                </tr>
              </thead>
              <tbody>
                ${filtered.map(row => `
                  <tr>
                    <td class="strong client-cell" title="${escapeHtml(clientLabel(row))}">${escapeHtml(clientLabel(row))}</td>
                    <td>${statusBadge(row.activation_status)}</td>
                    <td class="muted">${escapeHtml((row.kam_name || "").split(" ")[0] || "-")}</td>
                    <td class="secondary">${fmtDate(row.account_creation_date) || "-"}</td>
                    <td class="strong">${escapeHtml(bucketLabel(row.movement))}</td>
                    <td>${row.priority === "Blocking" ? `<span class="badge" style="background:var(--bg-danger);color:var(--text-danger)">${escapeHtml(row.type)}</span>` : `<span class="badge" style="background:var(--surface-1);color:var(--text-secondary)">${escapeHtml(row.type)}</span>`}</td>
                    <td class="secondary">${escapeHtml(row.detail || "-")}</td>
                    <td class="secondary">${fmtDate(row.stuck_from) || "-"}</td>
                    <td>${dayChip(row.stuck_days, 7, 30)}</td>
                    <td class="muted">${escapeHtml(row.age_bucket)}</td>
                    <td>${row.priority === "Blocking" ? `<span class="badge" style="background:var(--bg-danger);color:var(--text-danger)">Blocking</span>` : `<span class="badge" style="background:var(--surface-1);color:var(--text-secondary)">Open</span>`}</td>
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </div>
        </div>
      `;

      const search = els.actionablesView.querySelector("#actionableSearch");
      const reset = els.actionablesView.querySelector("#actionableReset");
      search?.addEventListener("input", event => { state.actionableSearch = event.target.value; render(); });
      reset?.addEventListener("click", () => {
        state.actionableStages = [];
        state.actionableTypes = [];
        state.actionablePriorities = [];
        state.actionableAges = [];
        state.actionableClients = [];
        state.actionableOpenFilter = null;
        state.actionableSearch = "";
        render();
      });
      els.actionablesView.querySelectorAll("[data-actionable-bucket]").forEach(card => {
        card.addEventListener("click", () => {
          const bucket = card.dataset.actionableBucket;
          const cardTypes = (card.dataset.actionableCardTypes || "").split("||").filter(Boolean);
          const selected = new Set(state.actionableStages);
          const selectedTypes = new Set(state.actionableTypes);
          const isActive = selected.has(bucket) && (!cardTypes.length || cardTypes.every(type => selectedTypes.has(type)));
          if (isActive) {
            selected.delete(bucket);
            cardTypes.forEach(type => selectedTypes.delete(type));
          } else {
            selected.add(bucket);
            if (cardTypes.length) cardTypes.forEach(type => selectedTypes.add(type));
            else selectedTypes.clear();
          }
          state.actionableStages = [...selected];
          state.actionableTypes = [...selectedTypes];
          render();
        });
      });
      els.actionablesView.querySelectorAll("[data-actionable-filter]").forEach(filter => {
        filter.addEventListener("click", event => {
          event.stopPropagation();
          const id = filter.dataset.actionableFilter;
          const action = event.target.closest("[data-actionable-filter-action]");
          if (event.target.closest(".month-button")) {
            state.actionableOpenFilter = state.actionableOpenFilter === id ? null : id;
            render();
            return;
          }
          if (action) {
            setActionableFilterValues(id, []);
            state.actionableOpenFilter = id;
            render();
          }
        });
        filter.addEventListener("change", event => {
          event.stopPropagation();
          if (event.target.type !== "checkbox") return;
          const id = filter.dataset.actionableFilter;
          const selected = new Set(getActionableFilterValues(id));
          if (event.target.checked) selected.add(event.target.value);
          else selected.delete(event.target.value);
          setActionableFilterValues(id, [...selected]);
          state.actionableOpenFilter = id;
          render();
        });
      });
    }

    function renderClients() {
      const rows = filteredQ1()
        .filter(row => !state.clientSearch || clientLabel(row).toLowerCase().includes(state.clientSearch.toLowerCase()));
      const sorted = sortRows(rows, state.sorts.clients);
      const allPlatforms = [...new Set(state.q3.map(row => row.platform_name).filter(isPresent))].sort();
      els.clientsView.innerHTML = `
        <div class="panel table-shell">
          <div class="table-tools">
            <input class="input" id="clientSearch" type="search" placeholder="Search client" value="${escapeHtml(state.clientSearch)}">
            <span class="muted">${sorted.length} clients</span>
            <div class="legend">
              <span style="background:var(--bg-success);color:var(--text-success)">Green &le; good</span>
              <span style="background:var(--bg-warning);color:var(--text-warning)">Amber = moderate</span>
              <span style="background:var(--bg-danger);color:var(--text-danger)">Red = slow</span>
              <span style="background:var(--bg-pro);color:var(--text-pro)">Purple = anomaly</span>
            </div>
          </div>
          <div class="table-wrap">
            <table>
              <thead>
                <tr>
                  ${sortableTh("Client Name", "clients", "client_name")}
                  <th>Status</th>
                  <th>KAM</th>
                  ${sortableTh("Created", "clients", "account_creation_date")}
                  <th class="tat-col">Create<br>&rarr; Dash</th>
                  <th class="tat-col">Dash<br>&rarr; KO</th>
                  <th class="tat-col">Dash<br>&rarr; Act</th>
                  <th class="tat-col">Create<br>&rarr; Full</th>
                  <th>Platforms</th>
                  <th>Action Activity</th>
                </tr>
              </thead>
              <tbody>
                ${sorted.map(row => `
                  <tr>
                    <td class="strong client-cell" title="${escapeHtml(clientLabel(row))}">${escapeHtml(clientLabel(row))}</td>
                    <td>${statusBadge(row.activation_status)}</td>
                    <td class="muted">${escapeHtml((row.kam_name || "").split(" ")[0] || "-")}</td>
                    <td class="secondary">${fmtDate(row.account_creation_date) || "-"}</td>
                    <td class="tat-col">${dayChip(row.days_creation_to_dashboard_live, 7, 14)}</td>
                    <td class="tat-col">${dayChip(row.days_dashboard_live_to_kickoff, 7, 14)}</td>
                    <td class="tat-col">${dayChip(row.days_dashboard_live_to_first_action, 21, 45)}</td>
                    <td class="tat-col">${dayChip(row.days_creation_to_full_dashboard_live, 14, 30)}</td>
                    <td>${platformSummary(row.client_uid, allPlatforms)}</td>
                    <td>${actionSummary(row)}</td>
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </div>
        </div>
      `;
      els.clientsView.querySelector("#clientSearch")?.addEventListener("input", event => {
        state.clientSearch = event.target.value;
        render();
      });
    }

    // Where a GST number's data comes from. The backend sends has_credentials
    // (whether a portal login is saved). Older backend builds only returned rows
    // WITH a login and no flag, so a missing flag means "has a login".
    function gstHasLogin(row) {
      return row.has_credentials !== false;
    }

    // PORTAL = saved login, or a successful portal upload on record (a login that
    // was removed later); MANUAL = neither, but invoices exist (loaded from manual
    // file uploads); NONE = no login, no portal upload and no invoices.
    function gstSource(row) {
      if (gstHasLogin(row) || isPresent(row.first_successful_upload_at)) return "PORTAL";
      return isPresent(row.first_invoice_date) ? "MANUAL" : "NONE";
    }

    function sourceBadge(row) {
      const kind = gstSource(row);
      const [label, bg, fg] = {
        PORTAL: ["Portal login", "var(--bg-success)", "var(--text-success)"],
        MANUAL: ["Manual upload", "var(--bg-warning)", "var(--text-warning)"],
        NONE: ["No data", "var(--surface-1)", "var(--text-muted)"]
      }[kind];
      return `<span class="badge" style="background:${bg};color:${fg};border:1px solid var(--border)">${label}</span>`;
    }

    // Same live statuses as the EMS GST Upload Tracker ("Upload status today").
    const UPLOAD_STATUSES = [
      "Due - upload now", "Password issue", "Tried - error", "Tried - no data found",
      "Locked (24h rule)", "No credentials", "Uploaded today"
    ];

    function uploadStatusPill(status) {
      if (!isPresent(status)) return `<span class="muted">-</span>`;
      const [bg, fg] = {
        "Uploaded today": ["var(--bg-success)", "var(--text-success)"],
        "Locked (24h rule)": ["var(--bg-pro)", "var(--text-pro)"],
        "Due - upload now": ["var(--bg-warning)", "var(--text-warning)"],
        "Password issue": ["var(--bg-danger)", "var(--text-danger)"],
        "Tried - error": ["var(--bg-danger)", "var(--text-danger)"]
      }[status] || ["var(--surface-1)", "var(--text-muted)"];
      return `<span class="badge" style="background:${bg};color:${fg};border:1px solid var(--border)">${escapeHtml(status)}</span>`;
    }

    // ---- Platform sync times --------------------------------------------------
    // Backend fields: last_platform_sync_at (last automated platform sync; the
    // same timestamp the product's Data Sync popup shows) and last_ledger_at
    // (last manual ledger upload; only platforms with ledger uploads have one).
    // Both are UTC timestamps. Older backends send neither.
    const IST_STAMP = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hour12: false });

    function istDayNow() {
      return new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);
    }

    function parseUtcStamp(value) {
      if (!isPresent(value)) return null;
      const raw = String(value);
      const date = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(raw) ? raw : `${raw}Z`);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    // TODAY (0 days), RECENT (1-2), WEEK (3-7), OLD (over 7), NEVER (nothing recorded)
    function stampAgeBucket(value) {
      const at = parseUtcStamp(value);
      if (!at) return "NEVER";
      const day = new Date(at.getTime() + 330 * 60000).toISOString().slice(0, 10);
      const days = Math.round((Date.parse(istDayNow()) - Date.parse(day)) / 86400000);
      if (days <= 0) return "TODAY";
      if (days <= 2) return "RECENT";
      return days <= 7 ? "WEEK" : "OLD";
    }

    // "03 Nov '26, 17:05" in IST, coloured by age. emptyLabel is shown when nothing is recorded.
    function stampCell(value, field, row, emptyLabel) {
      if (row.last_platform_sync_at === undefined && row.last_ledger_at === undefined) return `<span class="muted">-</span>`;
      const at = parseUtcStamp(value);
      if (!at) return `<span class="muted">${emptyLabel}</span>`;
      const bucket = stampAgeBucket(value);
      const [bg, fg] = { TODAY: ["--bg-success", "--text-success"], RECENT: ["--bg-success", "--text-success"], WEEK: ["--bg-warning", "--text-warning"], OLD: ["--bg-danger", "--text-danger"] }[bucket];
      const label = `${fmtDay(new Date(at.getTime() + 330 * 60000).toISOString())}, ${IST_STAMP.format(at)}`;
      return `<span class="day-chip" style="white-space:nowrap;background:var(${bg});color:var(${fg})">${label}</span>`;
    }

    // ---- GST / Platform tab filters -----------------------------------------
    const INVOICE_OPTIONS = [["ALL", "Invoices: any"], ["HAS", "Has invoices"], ["NONE", "No invoices"]];

    function filterSelect(id, value, options) {
      return `<select class="select" id="${id}" aria-label="${escapeHtml(options[0][1])}">${options
        .map(([v, label]) => `<option value="${escapeHtml(v)}"${v === value ? " selected" : ""}>${escapeHtml(label)}</option>`)
        .join("")}</select>`;
    }

    function distinctOptions(rows, key, allLabel) {
      const values = [...new Set(rows.map(row => row[key]).filter(isPresent))].sort();
      return [["ALL", allLabel], ...values.map(v => [String(v), String(v)])];
    }

    function invoiceMatches(filter, first) {
      const has = isPresent(first);
      return filter === "ALL" || (filter === "HAS" ? has : !has);
    }

    function gstRowPasses(row, f, months) {
      const q = f.search.trim().toLowerCase();
      if (q && !`${clientLabel(row)} ${row.gst_number || ""} ${row.pan_number || ""}`.toLowerCase().includes(q)) return false;
      if (f.source !== "ALL" && gstSource(row) !== f.source) return false;
      if (f.today !== "ALL" && row.upload_status_today !== f.today) return false;
      if (f.gstStatus !== "ALL" && row.gst_status !== f.gstStatus) return false;
      const uploaded = isPresent(row.first_successful_upload_at);
      if (f.uploaded === "YES" && !uploaded) return false;
      if (f.uploaded === "NO" && uploaded) return false;
      const done = new Set(Array.isArray(row.uploaded_months) ? row.uploaded_months : []);
      const have = months.filter(m => done.has(m.key)).length;
      if (f.months === "ALL6" && have !== months.length) return false;
      if (f.months === "MISSING" && have === months.length) return false;
      if (f.months === "NOCURRENT" && done.has(months[months.length - 1].key)) return false;
      if (f.months === "NONE" && have !== 0) return false;
      if (!invoiceMatches(f.invoices, row.first_invoice_date)) return false;
      return true;
    }

    function platformRowPasses(row, f) {
      const q = f.search.trim().toLowerCase();
      if (q && !`${clientLabel(row)} ${row.platform_name || ""} ${row.customer_id || ""}`.toLowerCase().includes(q)) return false;
      const live = platformIsLive(row);
      if (f.live === "YES" && !live) return false;
      if (f.live === "NO" && live) return false;
      if (f.billing !== "ALL" && String(row.billing_model || "") !== f.billing) return false;
      const grn = isPresent(row.first_successful_grn_upload_at);
      if (f.grn === "YES" && !grn) return false;
      if (f.grn === "NO" && grn) return false;
      if (!invoiceMatches(f.invoices, row.first_grn_date)) return false;
      if (f.autoSync !== "ALL" && stampAgeBucket(row.last_platform_sync_at) !== f.autoSync) return false;
      const ledgerBucket = stampAgeBucket(row.last_ledger_at);
      if (f.ledger === "UPLOADED" && ledgerBucket === "NEVER") return false;
      if (f.ledger === "NEVER" && ledgerBucket !== "NEVER") return false;
      if (f.ledger === "OLD" && ledgerBucket !== "OLD") return false;
      return true;
    }

    // Wire a view's filter controls (id -> filter key) and its Clear button.
    function bindFilterControls(view, controls, filters, defaults, extraReset) {
      for (const [id, key] of Object.entries(controls)) {
        const el = view.querySelector(`#${id}`);
        el?.addEventListener(el.tagName === "INPUT" ? "input" : "change", event => {
          filters[key] = event.target.value;
          render();
        });
      }
      view.querySelector(".clear-filters")?.addEventListener("click", () => {
        Object.assign(filters, defaults);
        extraReset?.();
        render();
      });
    }

    function renderPlatforms() {
      const ids = uidSet(filteredQ1());
      const platforms = [...new Set(state.q3.map(row => row.platform_name).filter(isPresent))].sort();
      const baseRows = state.q3.filter(row =>
        ids.has(String(row.client_uid)) &&
        (state.platformFilter === "ALL" || row.platform_name === state.platformFilter)
      );
      const pf = state.platformFilters;
      const rows = baseRows.filter(row => platformRowPasses(row, pf));
      const sorted = sortRows(rows, state.sorts.platforms);
      const liveCount = rows.filter(platformIsLive).length;
      const filtersActive = state.platformFilter !== "ALL" || Object.keys(PLATFORM_FILTER_DEFAULTS).some(key => pf[key] !== PLATFORM_FILTER_DEFAULTS[key]);
      els.platformsView.innerHTML = `
        <div class="panel table-shell">
          <div class="table-tools">
            <div id="platformFilterMount"></div>
            <input class="input" id="platformSearch" type="search" placeholder="Search client / platform / customer ID" value="${escapeHtml(pf.search)}">
            ${filterSelect("platformLive", pf.live, [["ALL", "Live: any"], ["YES", "Live"], ["NO", "Not live"]])}
            ${filterSelect("platformBilling", pf.billing, distinctOptions(baseRows, "billing_model", "Billing: any"))}
            ${filterSelect("platformGrn", pf.grn, [["ALL", "1st GRN: any"], ["YES", "GRN uploaded"], ["NO", "No GRN upload"]])}
            ${filterSelect("platformInvoices", pf.invoices, [["ALL", "GRN dates: any"], ["HAS", "Has GRN dates"], ["NONE", "No GRN dates"]])}
            ${filterSelect("platformAutoSync", pf.autoSync, [["ALL", "Last auto sync: any"], ["TODAY", "Today"], ["RECENT", "1\u20132 days ago"], ["WEEK", "3\u20137 days ago"], ["OLD", "Older than 7 days"], ["NEVER", "Never"]])}
            ${filterSelect("platformLedger", pf.ledger, [["ALL", "Ledger upload: any"], ["UPLOADED", "Uploaded"], ["NEVER", "Never"], ["OLD", "Older than 7 days"]])}
            ${filtersActive ? `<button class="ghost-button clear-filters" type="button">Clear filters</button>` : ""}
            <span class="muted">${filtersActive ? `${sorted.length} of ${baseRows.length}` : sorted.length} rows</span>
            <span class="muted">${liveCount} live</span>
          </div>
          <div class="table-wrap">
            <table>
              <thead>
                <tr>
                  ${sortableTh("Client", "platforms", "client_name")}
                  <th>Status</th>
                  ${sortableTh("Platform", "platforms", "platform_name")}
                  <th>Live</th>
                  <th>Billing</th>
                  ${sortableTh("Created", "platforms", "account_creation_date")}
                  ${sortableTh("Created &rarr; Platform Live TAT", "platforms", "days_creation_to_platform_live")}
                  ${sortableTh("1st GRN Upload", "platforms", "first_successful_grn_upload_at")}
                  ${sortableTh("GRN date range", "platforms", "first_grn_date")}
                  ${sortableTh("Last auto sync", "platforms", "last_platform_sync_at")}
                  ${sortableTh("Last manual (ledger) upload", "platforms", "last_ledger_at")}
                  <th>Customer ID</th>
                </tr>
              </thead>
              <tbody>
                ${sorted.map(row => `
                  <tr>
                    <td class="strong">${escapeHtml(clientLabel(row))}</td>
                    <td>${statusBadge(row.activation_status)}</td>
                    <td>${platformBadge(row.platform_name)}</td>
                    <td>${booleanIndicator("Live", platformIsLive(row))}</td>
                    <td class="muted">${escapeHtml(row.billing_model || "-")}</td>
                    <td class="secondary">${fmtDate(row.account_creation_date) || "-"}</td>
                    <td>${dayChip(row.days_creation_to_platform_live, 7, 14)}</td>
                    <td>${isPresent(row.first_successful_grn_upload_at) ? `<span class="success-text">${fmtDate(row.first_successful_grn_upload_at)}</span>` : `<span class="muted">-</span>`}</td>
                    <td>${dateRangeText(row.first_grn_date, row.last_grn_date)}</td>
                    <td>${stampCell(row.last_platform_sync_at, "last_platform_sync_at", row, "Never")}</td>
                    <td>${stampCell(row.last_ledger_at, "last_ledger_at", row, "-")}</td>
                    <td class="muted">${escapeHtml(row.customer_id || "-")}</td>
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </div>
        </div>
      `;
      bindFilterControls(els.platformsView, {
        platformSearch: "search", platformLive: "live", platformBilling: "billing",
        platformGrn: "grn", platformInvoices: "invoices", platformAutoSync: "autoSync", platformLedger: "ledger"
      }, state.platformFilters, PLATFORM_FILTER_DEFAULTS, () => { state.platformFilter = "ALL"; });
      window.renderOnboardingPlatformFilter?.({ options: platforms, value: state.platformFilter, onChange: value => { state.platformFilter = value; render(); } });
    }

    // Date-only values (e.g. invoice document_date) arrive as UTC midnight, so
    // read them with UTC getters to avoid shifting the day in other time zones.
    function fmtDay(iso) {
      if (!isPresent(iso)) return "";
      const date = new Date(iso);
      if (Number.isNaN(date.getTime())) return "";
      return `${String(date.getUTCDate()).padStart(2, "0")} ${MONTH_NAMES[date.getUTCMonth()]} '${String(date.getUTCFullYear()).slice(2)}`;
    }

    // "start -> end" of the invoice dates for this GST (own_invoice.document_date).
    function invoiceRange(row) {
      return dateRangeText(row.first_invoice_date, row.last_invoice_date);
    }

    // Plain "start -> end" chip for a date-only range (no invoice count).
    function dateRangeText(startIso, endIso) {
      const start = fmtDay(startIso);
      const end = fmtDay(endIso);
      if (!start || !end) return `<span class="muted">-</span>`;
      return `<span style="white-space:nowrap">${start} &rarr; ${end}</span>`;
    }

    // Last 6 months (current IST month + previous 5), oldest first, as YYYY-MM keys.
    const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    function lastSixMonths() {
      const ist = new Date(Date.now() + 330 * 60000);
      const out = [];
      for (let back = 5; back >= 0; back--) {
        const d = new Date(Date.UTC(ist.getUTCFullYear(), ist.getUTCMonth() - back, 1));
        const month = d.getUTCMonth();
        out.push({
          key: `${d.getUTCFullYear()}-${String(month + 1).padStart(2, "0")}`,
          label: MONTH_NAMES[month],
          title: `${MONTH_NAMES[month]} ${d.getUTCFullYear()}`
        });
      }
      return out;
    }

    // One chip per month: tick if a completed upload had files for that month
    // (month is read from the file name by the backend), dash otherwise.
    function monthChips(row, months) {
      const done = new Set(Array.isArray(row.uploaded_months) ? row.uploaded_months : []);
      return `<span style="display:inline-flex;gap:3px">${months.map(m => done.has(m.key)
        ? `<span title="${m.title}: uploaded" style="display:inline-flex;flex-direction:column;align-items:center;min-width:28px;padding:1px 3px;border-radius:5px;background:var(--bg-success);color:var(--text-success);font-size:9px;line-height:1.25"><span>${m.label}</span><strong style="font-size:11px">&#10003;</strong></span>`
        : `<span title="${m.title}: not uploaded" style="display:inline-flex;flex-direction:column;align-items:center;min-width:28px;padding:1px 3px;border-radius:5px;color:var(--text-muted);font-size:9px;line-height:1.25"><span>${m.label}</span><span style="font-size:11px">&ndash;</span></span>`
      ).join("")}</span>`;
    }

    function renderGsts() {
      const ids = uidSet(filteredQ1());
      const baseRows = state.q2.filter(row => ids.has(String(row.client_uid)));
      const months = lastSixMonths();
      const gf = state.gstFilters;
      const rows = baseRows.filter(row => gstRowPasses(row, gf, months));
      const sorted = sortRows(rows, state.sorts.gsts);
      const uploadCount = rows.filter(row => isPresent(row.first_successful_upload_at)).length;
      const filtersActive = Object.keys(GST_FILTER_DEFAULTS).some(key => gf[key] !== GST_FILTER_DEFAULTS[key]);
      if (!state.q2.length) {
        els.gstsView.innerHTML = `
          <div class="panel empty">
            <h3>No GST data loaded</h3>
            <p>Q2 data is required for the GST table.</p>
            <button class="primary-button" type="button" id="loadGstEmpty">Load Q2 data</button>
          </div>
        `;
        els.gstsView.querySelector("#loadGstEmpty")?.addEventListener("click", openModal);
        return;
      }
      els.gstsView.innerHTML = `
        <div class="panel table-shell">
          <div class="table-tools">
            <input class="input" id="gstSearch" type="search" placeholder="Search client / GST number / PAN" value="${escapeHtml(gf.search)}">
            ${filterSelect("gstSource", gf.source, [["ALL", "Source: any"], ["PORTAL", "Portal login"], ["MANUAL", "Manual upload"], ["NONE", "No data"]])}
            ${filterSelect("gstToday", gf.today, [["ALL", "Status today: any"], ...UPLOAD_STATUSES.map(v => [v, v])])}
            ${filterSelect("gstStatus", gf.gstStatus, distinctOptions(baseRows, "gst_status", "GST status: any"))}
            ${filterSelect("gstUploaded", gf.uploaded, [["ALL", "Upload: any"], ["YES", "Uploaded"], ["NO", "Not uploaded"]])}
            ${filterSelect("gstMonths", gf.months, [["ALL", "Last 6 months: any"], ["ALL6", "Uploaded all 6 months"], ["MISSING", "Missing at least 1 month"], ["NOCURRENT", "Missing current month"], ["NONE", "No uploads in 6 months"]])}
            ${filterSelect("gstInvoices", gf.invoices, INVOICE_OPTIONS)}
            ${filtersActive ? `<button class="ghost-button clear-filters" type="button">Clear filters</button>` : ""}
            <span class="muted">${filtersActive ? `${sorted.length} of ${baseRows.length}` : sorted.length} GST records</span>
            <span class="muted">${uploadCount} uploaded</span>
          </div>
          <div class="table-wrap">
            <table>
              <thead>
                <tr>
                  ${sortableTh("Client", "gsts", "client_name")}
                  <th>Status</th>
                  <th>Uploaded</th>
                  <th>GST status</th>
                  <th>Source</th>
                  ${sortableTh("Upload status today", "gsts", "upload_status_today")}
                  ${sortableTh("GST number", "gsts", "gst_number")}
                  ${sortableTh("Created", "gsts", "account_creation_date")}
                  ${sortableTh("Created &rarr; GST Upload TAT", "gsts", "days_creation_to_gst_upload")}
                  ${sortableTh("1st Upload", "gsts", "first_successful_upload_at")}
                  <th>Last 6 months</th>
                  ${sortableTh("Invoice date range", "gsts", "first_invoice_date")}
                  <th>PAN</th>
                </tr>
              </thead>
              <tbody>
                ${sorted.map(row => `
                  <tr>
                    <td class="strong">${escapeHtml(clientLabel(row))}</td>
                    <td>${statusBadge(row.activation_status)}</td>
                    <td>${gstSource(row) === "PORTAL" ? booleanIndicator("Upload", isPresent(row.first_successful_upload_at)) : `<span class="muted">-</span>`}</td>
                    <td class="muted">${escapeHtml(row.gst_status || "-")}</td>
                    <td>${sourceBadge(row)}</td>
                    <td>${uploadStatusPill(row.upload_status_today)}</td>
                    <td style="font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;font-size:10px">${escapeHtml(row.gst_number || "-")}</td>
                    <td class="secondary">${fmtDate(row.account_creation_date) || "-"}</td>
                    <td>${dayChip(row.days_creation_to_gst_upload, 7, 14)}</td>
                    <td>${isPresent(row.first_successful_upload_at) ? `<span class="success-text">${fmtDate(row.first_successful_upload_at)}</span>` : `<span class="muted">-</span>`}</td>
                    <td>${monthChips(row, months)}</td>
                    <td>${invoiceRange(row)}</td>
                    <td class="muted">${escapeHtml(row.pan_number || "-")}</td>
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </div>
        </div>
      `;
      bindFilterControls(els.gstsView, {
        gstSearch: "search", gstSource: "source", gstToday: "today", gstStatus: "gstStatus", gstUploaded: "uploaded",
        gstMonths: "months", gstInvoices: "invoices"
      }, state.gstFilters, GST_FILTER_DEFAULTS);
    }

    function attachSortHandlers() {
      root.querySelectorAll("th.sortable").forEach(th => {
        th.addEventListener("click", () => {
          const table = th.dataset.table;
          const col = th.dataset.col;
          const sort = state.sorts[table];
          state.sorts[table] = {
            col,
            dir: sort.col === col && sort.dir === "asc" ? "desc" : "asc"
          };
          render();
        });
      });
    }

    // Every view below is rebuilt by assigning innerHTML, which destroys and
    // recreates whatever the user was typing into. The client and actionable
    // search boxes live inside those views and call render() on each keystroke,
    // so without this they lose focus after every single character. Remember
    // what was focused and where the caret sat, then put it back on the
    // replacement node.
    function captureFocus() {
      const active = root.activeElement;
      if (!active || !active.id) return null;
      // selectionStart is only exposed on text-like inputs; it throws on others
      // (number, checkbox, ...), so read it defensively rather than by type.
      let start = null;
      let end = null;
      try {
        start = active.selectionStart;
        end = active.selectionEnd;
      } catch {
        start = null;
      }
      return { id: active.id, start, end };
    }

    function restoreFocus(captured) {
      if (!captured) return;
      const next = root.getElementById(captured.id);
      if (!next || next === root.activeElement) return;
      next.focus();
      if (captured.start === null || typeof next.setSelectionRange !== "function") return;
      try {
        next.setSelectionRange(captured.start, captured.end);
      } catch {
        // Element no longer supports a selection range — focus alone is enough.
      }
    }

    function render() {
      if (disposed) return;
      const focused = captureFocus();
      renderHeader();
      for (const view of ["funnel", "actionables", "trends", "clients", "platforms", "gsts"]) {
        root.getElementById(`${view}View`).hidden = state.tab !== view;
      }
      els.tabs.querySelectorAll(".tab").forEach(tab => tab.classList.toggle("active", tab.dataset.tab === state.tab));
      els.statusFilter.querySelectorAll("button").forEach(button => button.classList.toggle("active", button.dataset.value === state.status));
      renderFunnel();
      renderActionables();
      renderTrends();
      renderClients();
      renderPlatforms();
      renderGsts();
      restoreFocus(focused);
    }

    function openModal() {
      els.loadError.style.display = "none";
      els.loadError.textContent = "";
      els.q1Input.value = "";
      els.q2Input.value = "";
      els.q3Input.value = "";
      els.modal.classList.add("open");
      els.q1Input.focus();
    }

    function closeModal() {
      els.modal.classList.remove("open");
    }

    async function loadLocalData() {
      const files = ["query_output_1.json", "query_output_2.json", "query_output_3.json"];
      const [q1, q2, q3] = await Promise.all(files.map(async file => {
        const response = await fetch(`${process.env.PUBLIC_URL}/onboarding/${file}`, { cache: "no-store" });
        if (!response.ok) throw new Error(`${file}: ${response.status}`);
        const json = await response.json();
        return Array.isArray(json) ? json : (json.result || []);
      }));
      if (disposed) return;
      state.q1 = q1;
      state.q2 = q2;
      state.q3 = q3;
      els.dataStatus.textContent = `ARPFlow - ${state.q1.length} clients - ${state.q2.length} GST rows - ${state.q3.length} platform rows`;
      render();
    }

    async function loadApiData() {
      // apiConfig.baseUrl already includes the /qsync prefix (same convention
      // as src/utils/api.js's fetchClients/fetchUsers/fetchWeeklyMetrics).
      const endpoints = [
        { path: "/api/kpi-dashboard/OnboardingSummary", key: "clients" },
        { path: "/api/kpi-dashboard/GstUploads", key: "gstUploads" },
        { path: "/api/kpi-dashboard/PlatformUploads", key: "platformUploads" },
      ];
      const [q1, q2, q3] = await Promise.all(endpoints.map(async ({ path, key }) => {
        const response = await fetch(`${apiConfig.baseUrl}${path}`, {
          cache: "no-store",
          headers: apiConfig.headers,
        });
        if (!response.ok) throw new Error(`${path}: ${response.status}`);
        const json = await response.json();
        return Array.isArray(json) ? json : (json[key] || []);
      }));
      if (disposed) return;
      state.q1 = q1;
      state.q2 = q2;
      state.q3 = q3;
      els.dataStatus.textContent = `ARPFlow - ${state.q1.length} clients - ${state.q2.length} GST rows - ${state.q3.length} platform rows`;
      render();
    }

    function loadFromModal() {
      try {
        if (els.q1Input.value.trim()) state.q1 = parseJson(els.q1Input.value);
        if (els.q2Input.value.trim()) state.q2 = parseJson(els.q2Input.value);
        if (els.q3Input.value.trim()) state.q3 = parseJson(els.q3Input.value);
        els.dataStatus.textContent = `ARPFlow - ${state.q1.length} clients - ${state.q2.length} GST rows - ${state.q3.length} platform rows`;
        closeModal();
        render();
      } catch (error) {
        els.loadError.textContent = `JSON parse error: ${error.message}`;
        els.loadError.style.display = "block";
      }
    }

    els.statusFilter.addEventListener("click", event => {
      const button = event.target.closest("button[data-value]");
      if (!button) return;
      state.status = button.dataset.value;
      render();
    });
    els.accountMonthFilter.addEventListener("click", event => {
      event.stopPropagation();
      const toggle = event.target.closest("#monthFilterToggle");
      const action = event.target.closest("[data-month-action]");
      if (toggle) {
        state.monthMenuOpen = !state.monthMenuOpen;
        render();
        return;
      }
      if (action) {
        state.accountMonths = [];
        state.monthMenuOpen = true;
        render();
      }
    });
    els.accountMonthFilter.addEventListener("change", event => {
      event.stopPropagation();
      if (event.target.type !== "checkbox") return;
      const month = event.target.value;
      const selected = new Set(state.accountMonths);
      if (event.target.checked) selected.add(month);
      else selected.delete(month);
      state.accountMonths = [...selected].sort().reverse();
      state.monthMenuOpen = true;
      render();
    });
    els.tabs.addEventListener("click", event => {
      const button = event.target.closest("button[data-tab]");
      if (!button) return;
      state.tab = button.dataset.tab;
      render();
    });
    els.openRefresh.addEventListener("click", openModal);
    els.closeRefresh.addEventListener("click", closeModal);
    els.cancelRefresh.addEventListener("click", closeModal);
    els.loadRefresh.addEventListener("click", loadFromModal);
    els.modal.addEventListener("click", event => {
      if (event.target === els.modal) closeModal();
    });
    root.addEventListener("click", event => {
      if (!els.accountMonthFilter.contains(event.target) && state.monthMenuOpen) {
        state.monthMenuOpen = false;
        render();
      }
      if (!event.target.closest("[data-actionable-filter]") && state.actionableOpenFilter) {
        state.actionableOpenFilter = null;
        render();
      }
    });
    root.addEventListener("keydown", event => {
      if (event.key === "Escape") {
        closeModal();
        if (state.monthMenuOpen) {
          state.monthMenuOpen = false;
          render();
        }
        if (state.actionableOpenFilter) {
          state.actionableOpenFilter = null;
          render();
        }
      }
    });

    if (apiConfig && apiConfig.baseUrl) {
      loadApiData().catch(error => {
        if (disposed) return;
        els.dataStatus.textContent = `Live API data was not loaded: ${error.message}`;
        render();
      });
    } else {
      loadLocalData().catch(error => {
        if (disposed) return;
        els.dataStatus.textContent = `Local JSON files were not loaded: ${error.message}`;
        render();
      });
    }
  
  return () => { disposed = true; };
}
